import { type AlertSeverity, Observable, observe, Scope } from 'cube'

export type QuickLink = {
    label: string
    onClick: () => Promise<void>
}

@Observable
export class HeaderScope extends Scope {
    @observe() version = '1.0.0'
    @observe() subtitle = 'DEVEL'
    @observe() title = 'unknown'
    @observe() loggedIn = false
    @observe() avatar = 'https://picsum.photos/id/823/400'

    onBuscaTermo = Scope.ASYNC_ACTION_STRING

    quickLinkData = [] as QuickLink[]
    @observe() quickLinkVersion = 0

    onHome = Scope.ASYNC_ACTION
    onClickLogin = Scope.ASYNC_ACTION
    onIndicadores = Scope.ASYNC_ACTION
    onTrocaTema = Scope.ASYNC_ACTION
    onAlert = Scope.ASYNC_ACTION_STRING
}

@Observable
export class HomeScope extends Scope {
    onOpenAlert = Scope.ASYNC_ACTION_ONE<AlertSeverity>()
}

export type MenuType = 'normal' | 'push' | 'contextual'
export type MenuSize = 2 | 3 | 4 | 6
export interface MenuItem {
    label?: string | Scope
    submenu?: MenuItem[]
    icon?: string
    divider?: boolean
    expanded?: boolean
    active?: boolean
    danger?: boolean
    keepMenuActive?: boolean
    onClick?: () => Promise<void>
}

@Observable
export class MenuScope extends Scope {
    @observe() type: MenuType = 'push'
    @observe() size: MenuSize = 2
    @observe() active = true

    @observe() version = 0
    items: MenuItem[] = []
}

export type ModalAction = {
    label?: string
    disabled?: boolean
    action?: () => void
}

type Dimension = number | string

@Observable
export class DialogScope extends Scope {
    @observe() title?: string = undefined

    @observe() minWidth?: Dimension = undefined
    @observe() minHeight?: Dimension = undefined
    @observe() height?: Dimension = undefined
    @observe() width?: Dimension = undefined

    @observe() keepOpenOnPrimaryAction?: boolean = undefined
    @observe() keepOpenOnSecondaryAction?: boolean = undefined
    @observe() focusOnPrimaryAction?: boolean = undefined
    @observe() focusOnSecondaryAction?: boolean = undefined
    @observe() primaryAction?: ModalAction = undefined
    @observe() secondaryAction?: ModalAction = undefined

    @observe() content?: Scope = undefined

    onClose = Scope.ASYNC_ACTION
}

@Observable
export class AlertScope extends DialogScope {
    @observe() severity: AlertSeverity = 'info'
    @observe() message?: string = undefined

    onClose = Scope.ASYNC_ACTION
}

@Observable
export class MainScope extends Scope {
    readonly header = new HeaderScope()
    readonly menu = new MenuScope()

    @observe() page?: Scope = undefined
    @observe() dialog?: DialogScope = undefined
    @observe() alert?: AlertScope = undefined

    onLogin = Scope.ASYNC_ACTION
    onHome = Scope.ASYNC_ACTION
    onAnaliseBulas = Scope.ASYNC_ACTION
    onAnaliseReacoes = Scope.ASYNC_ACTION
}
